<script xmlns="http://www.w3.org/1999/html">
export default {
  name: 'stockImg',
  data() {
    return {
      username: localStorage.getItem('name'),
      // 头部
      // 搜索
      searchName: "",
      // 筛选分类
      stockClass: "",
      options: [],
      optionProps: {
        expandTrigger: 'hover',
        title: "name",
        label: "name",
        value: "id",
        children: "children"
      },
      // 中间
      // 表格数据
      loading: true,
      tableData: [],
      fileData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      setVisible: false,
      fileDataList: [],
      dialogImageUrl: '',
      lookImgVisible: false,
      disabled: false,
      id: "",
      img: "",
      detailsImg: "",
      code: "",
      name: "",
    }
  },

  beforeMount() {
    this.getStock();
    this.$axios.get("/admin/stock/classSort").then((res) => {
      this.options = res.data.data
    })
  },
  methods: {
    getStock() {
      this.loading = true
      this.$axios.get("/admin/stock/class", {
        params: {
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          name: this.searchName,
          stockClass: this.stockClass
        }
      }).then((res) => {
        this.tableData = res.data.data.records
        this.total = res.data.data.total
        this.loading = false
      })
    },
    // 头部
    // 搜索
    search() {
      this.currentPage = 1
      this.getStock()
    },
    // 筛选分类
    selectClass() {
      this.currentPage = 1
      this.stockClass= this.stockClass[this.stockClass.length - 1]
      this.getStock()
    },
    // 筛选没有图片
    siftNull() {
      this.loading = true
      this.$axios.get("/admin/stock/classImgNull").then((res) => {
        this.tableData = res.data.data
        this.loading = false
      })
      document.getElementById("page").style.visibility = "hidden";//隐藏
    },
    // 重置
    searchClear() {
      this.currentPage = 1
      this.searchName = ""
      this.stockClass = ""
      this.getStock()
      document.getElementById("page").style.visibility = "visible";//显示
    },
    // 分页
    handleSizeChange(val) {
      this.pageSize = val
      this.getStock()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getStock()
    },
    // 编辑
    redact(e) {
      this.setVisible = true
      this.id = e.id
      this.code = e.code
      this.img = e.img
      this.detailsImg = e.detailsImg
      this.name = e.name
      if (e.img != null && e.img != '') {
        let img = e.img.split("|")
        for (const i of img) {
          this.fileDataList.push({url: '/image/' + i})
        }
      }
      if (e.detailsImg != null && e.detailsImg != '') {
        let detailsImg = e.detailsImg.split("|")
        for (const i of detailsImg) {
          this.fileData.push({url: '/image/' + i})
        }
      }
    },
    // 图片处理
    handleRemove(file) {
      let removeId = file.uid
      this.fileDataList.forEach((item, index) => {
        if (item.uid == removeId) {
          this.fileDataList.splice(index, 1)
        }
      })
    },
    handleRemove1(file) {
      let removeId = file.uid
      this.fileData.forEach((item, index) => {
        if (item.uid == removeId) {
          this.fileData.splice(index, 1)
        }
      })
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.lookImgVisible = true;
    },
    handleDownload(file) {
      let originalName = file.name;
      if (!originalName && file.url) {
        const urlParts = file.url.split('/');
        originalName = urlParts.pop() || 'image.webp';
      }
      if (!originalName) {
        originalName = 'image.webp';
      }

      const img = new Image();
      img.crossOrigin = 'Anonymous';
      img.src = file.url;

      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);

        // 转换为 PNG 的 DataURL
        const pngDataUrl = canvas.toDataURL('image/png');

        // 生成 PNG 文件名
        const pngName = originalName.replace(/\.webp$/i, '.png');
        // 如果原文件名没有 .webp 后缀，直接加 .png
        const finalName = pngName === originalName ? originalName + '.png' : pngName;

        // 触发下载
        const a = document.createElement('a');
        a.href = pngDataUrl;
        a.download = finalName;
        a.click();

        canvas.remove();
      };

      img.onerror = (err) => {
        console.error('图片加载失败，请检查 URL 或跨域配置', err);
      };
    },
    error() {
      this.$message.error("上传失败")
      this.$alert('请上传图片类型文件，或图片过大，图片最大为1MB，请使用画图工具将图片尺寸调小至1000像素以内', '上传失败', {
        confirmButtonText: '确定',
      });
    },
    success(response, file, fileList) {
      // this.fileDataList.push({url: '/image/' + file.response})
      this.fileDataList = fileList
      this.$message.success("上传成功")
    }, success1(response, file, fileList) {
      // this.fileDataList.push({url: '/image/' + file.response})
      this.fileData = fileList
      this.$message.success("上传成功")
    },
    exceed() {
      this.$message.warning("最多只可上传12张图片")
    },

    // 关闭对话框
    close() {
      this.setVisible = false
      this.id = ""
      this.code = ""
      this.name = ""
      this.img = ""
      this.detailsImg = ""
      this.fileDataList = []
      this.fileData = []
    },
    // 设置图片
    setImg() {
      let img = ''
      let detailsImg = ''
      for (const f of this.fileDataList) {
        if (f.name != null) {
          img += f.response + '|'
        } else {
          const arr = f.url.split("/")
          img += arr[arr.length - 2] + '/'
          img += arr[arr.length - 1] + '|'
        }
      }
      for (const f of this.fileData) {
        if (f.name != null) {
          detailsImg += f.response + '|'
        } else {
          const arr1 = f.url.split("/")
          detailsImg += arr1[arr1.length - 2] + '/'
          detailsImg += arr1[arr1.length - 1] + '|'
        }
      }
      this.$axios.post("/admin/classImg", {
        id: this.id,
        code: this.code,
        img: img.substring(0, img.length - 1),
        detailsImg: detailsImg.substring(0, detailsImg.length - 1),
      }).then((r) => {
        this.$axios.post("/admin/log", {
          "type": "管理员",
          "module": "图片管理",
          "name": this.username,
          "content": "设置了'" + this.name + "'的图片"
        })
        this.setVisible = false
        this.$message.success("设置成功")
        this.getStock()
      }).catch((e) => {
        this.$message.error("设置失败")
      })
    },
    closeImg() {
      this.dialogImageUrl = ''
      this.lookImgVisible = false
    },
    out() {
      this.$router.push({name: 'login'})
    }
  }
}
</script>
<template>
  <div>
    <el-header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>商品图片管理</el-breadcrumb-item>
        <div style="position: absolute; right: 100px;top: 20px;font-size: 15px">
          <div style="display:flex;align-items:center;">
            <el-avatar size="large" style="margin: 5px;"
                       src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"></el-avatar>
            {{ username }}
            <el-button type="text" @click="out" style="margin: 5px;">退出登录</el-button>
          </div>
        </div>
      </el-breadcrumb>
      搜索商品：
      <el-input class="topInput" placeholder="请输入要搜索的商品名称" prefix-icon="el-icon-search" v-model="searchName"
                clearable @keyup.enter.native="search"></el-input>
      <el-button type="primary" plain icon="el-icon-search" @click="search">搜索</el-button>
      分类查询：
      <el-cascader
        placeholder="请选择要查询的分类"
        v-model="stockClass"
        :options="options"
        :props="optionProps"
        @change="selectClass"></el-cascader>
      <el-button type="primary" plain @click="siftNull">筛选没有图片</el-button>
      <el-button type="danger" plain icon="el-icon-delete" @click="searchClear">重置</el-button>
    </el-header>
    <el-main class="el-main">
      <el-table
        id="listTable"
        v-loading="loading"
        :data="tableData"
        stripe
        border
        highlight-current-row
        current-row-key="id"
        max-height="500">
        <el-table-column prop="code" label="商品编号" align="center" width="110">
        </el-table-column>
        <el-table-column prop="name" label="商品名称" align="center" width="205">
        </el-table-column>
        <el-table-column prop="img" label="图片" width="300">
          <template slot-scope="scope">
            <div v-if="scope.row.img === null">
              无
            </div>
            <div v-if="scope.row.img != null">
              <el-image
                lazy
                scroll-container="#listTable .el-table__body-wrapper"
                fit="contain"
                v-for="item in scope.row.img.split('|')"
                :key="item.value"
                :src="'/image/'+item"
                style="width: 70px; height: 70px;margin-right: 20px;">
              </el-image>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="img" label="商品详情图片" width="300">
          <template slot-scope="scope">
            <div v-if="scope.row.detailsImg === null">
              无
            </div>
            <div v-if="scope.row.detailsImg != null">
              <el-image
                lazy
                scroll-container="#listTable .el-table__body-wrapper"
                fit="contain"
                v-for="item in scope.row.detailsImg.split('|')"
                :key="item.value"
                :src="'/image/'+item"
                style="width: 70px; height: 70px;margin-right: 20px;">
              </el-image>
            </div>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" align="center" width="70">
          <template slot-scope="scope">
            <el-button @click="redact(scope.row)" type="text" size="medium">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-footer class="el-footer">
      <el-pagination
        id="page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[5,10, 20, 50, 100]"
        :page-size="pageSize"
        :pager-count="11"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-footer>
    <el-dialog title="编辑图片" :visible.sync="setVisible" @close="close">
      商品编号：
      <el-input v-model="code" :disabled="true" style="width: 120px;" autocomplete="off"></el-input>
      商品名称：
      <el-input v-model="name" :disabled="true" style="width: 300px;" autocomplete="off"></el-input>
      <br>
      <el-upload
        class="el-upload"
        :on-error="error"
        :limit="12"
        :on-exceed="exceed"
        :on-success="success"
        action="/admin/img"
        list-type="picture-card"
        :multiple="true"
        :file-list="fileDataList"
      >
        <i slot="default" class="el-icon-plus"></i>
        <div slot="file" slot-scope="{file}">
          <img
            alt=""
            class="el-upload-list__item-thumbnail"
            :src="file.url"
          >
          <span class="el-upload-list__item-actions">
        <span
          class="el-upload-list__item-preview"
          @click="handlePictureCardPreview(file)"
        >
          <i class="el-icon-zoom-in"></i>
        </span>
        <span
          v-if="!disabled"
          class="el-upload-list__item-delete"
          @click="handleDownload(file)"
        >
          <i class="el-icon-download"></i>
        </span>
        <span
          v-if="!disabled"
          class="el-upload-list__item-delete"
          @click="handleRemove(file)"
        >
          <i class="el-icon-delete"></i>
        </span>
      </span>
        </div>
      </el-upload>
      <br>
      商品详情介绍图片
      <br>
      <el-upload
        class="el-upload"
        :on-error="error"
        :limit="12"
        :on-exceed="exceed"
        :on-success="success1"
        action="/admin/img"
        list-type="picture-card"
        :multiple="true"
        :file-list="fileData"
      >
        <i slot="default" class="el-icon-plus"></i>
        <div slot="file" slot-scope="{file}">
          <img
            alt=""
            class="el-upload-list__item-thumbnail"
            :src="file.url"
          >
          <span class="el-upload-list__item-actions">
        <span
          class="el-upload-list__item-preview"
          @click="handlePictureCardPreview(file)"
        >
          <i class="el-icon-zoom-in"></i>
        </span>
        <span
          v-if="!disabled"
          class="el-upload-list__item-delete"
          @click="handleDownload(file)"
        >
          <i class="el-icon-download"></i>
        </span>
        <span
          v-if="!disabled"
          class="el-upload-list__item-delete"
          @click="handleRemove1(file)"
        >
          <i class="el-icon-delete"></i>
        </span>
      </span>
        </div>
      </el-upload>

      <div slot="footer" class="dialog-footer">
        <el-button @click="close()">取 消</el-button>
        <el-button type="primary" @click="setImg()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="lookImgVisible" @close="closeImg">
      <img width="100%" :src="dialogImageUrl" alt="" append-to-body>
    </el-dialog>
  </div>
</template>
<style scoped>
.el-header {
  padding-top: 30px;
  margin-left: 25px;
}

.topInput {
  margin-top: 15px;
  margin-bottom: 30px;
  width: 200px;
}

.el-main {
  margin-top: 50px;
  margin-left: 25px;
}

.el-footer {
  text-align: center;
  margin-top: 30px;
}

.el-upload {
  margin: 30px;
}

.el-upload-list__item-thumbnail {
  object-fit: contain;
}
</style>



// WEBPACK FOOTER //
// src/views/stockImgView.vue